import React from "react";
import { Server, Globe } from "lucide-react";

const NVR = () => {
  // Replace this with your actual NVR IP
  const nvrIp = "192.168.1.100";

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-slate-900">NVR</h1>
        <p className="text-sm text-slate-500 mt-1">
          Network Video Recorder information.
        </p>
      </div>

      {/* IP Card */}
      <div className="max-w-md rounded-2xl border border-slate-200 bg-white shadow-sm p-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50">
            <Server className="h-6 w-6 text-blue-600" />
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">
              NVR IP Address
            </h2>
            <p className="text-xs text-slate-500">
              Primary recorder endpoint
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
          <div className="flex items-center gap-2">
            <Globe className="h-4 w-4 text-slate-500" />
            <span className="font-mono text-base font-semibold text-slate-800">
              {nvrIp}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NVR;